<app-side-menu>
  <div class="loca9-content">
    <!-- Menu Principal -->
    <div *ngIf="currentView === 'menu'">
      <div class="page-header">
        <h2><i class="fas fa-mobile-alt me-2"></i>Aplicativo Loca9</h2>
        <p class="page-subtitle">Gerencie as funcionalidades do aplicativo Loca9</p>
      </div>

      <div class="buttons-grid">
        <div
          *ngFor="let button of buttons"
          class="action-card"
          (click)="onButtonClick(button)"
        >
          <div class="card-icon" [style.background]="button.color">
            <i [class]="button.icon"></i>
          </div>
          <div class="card-info">
            <h3>{{ button.title }}</h3>
            <p>{{ button.description }}</p>
          </div>
          <div class="card-arrow">
            <i class="fas fa-chevron-right"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Campanhas -->
    <div *ngIf="currentView === 'campanhas'">
      <div class="page-header with-back">
        <button class="btn-back" (click)="goBack()">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div>
          <h2><i class="fas fa-bullhorn me-2"></i>Campanhas</h2>
          <p class="page-subtitle">Gerencie campanhas de marketing e comunicação</p>
        </div>
      </div>

      <app-table
        [title]="'Campanhas'"
        [data]="campanhas"
        [columns]="campanhasColumns"
        [showSearch]="true"
        [searchPlaceholder]="'Buscar campanhas...'"
        [clickable]="false">
        <app-button
          table-header-action
          text="Nova Campanha"
          [color]="'var(--primary-light)'"
          [height]="'42px'"
          (buttonClick)="newCampanha()">
        </app-button>
      </app-table>
    </div>

    <!-- Nova Campanha -->
    <div *ngIf="currentView === 'nova-campanha'">
      <div class="page-header with-back">
        <button class="btn-back" (click)="goBackToCampanhas()">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div>
          <h2><i class="fas fa-plus-circle me-2"></i>Nova Campanha</h2>
          <p class="page-subtitle">Preencha os dados da campanha</p>
        </div>
      </div>

      <div class="form-card">
        <div class="form-section">
          <h3 class="section-title"><i class="fas fa-info-circle me-2"></i>Informações da Campanha</h3>

          <div class="row g-3">
            <div class="col-md-12">
              <label class="form-label">Nome da Campanha</label>
              <input type="text" class="form-control" [(ngModel)]="campanhaForm.nome"
                placeholder="Digite o nome da campanha"
                [class.is-invalid]="!campanhaForm.nome && campanhaForm.nome !== undefined">
            </div>

            <div class="col-md-6">
              <label class="form-label">Início</label>
              <input type="date" class="form-control" [(ngModel)]="campanhaForm.inicio">
            </div>

            <div class="col-md-6">
              <label class="form-label">Fim</label>
              <input type="date" class="form-control" [(ngModel)]="campanhaForm.fim">
            </div>

            <div class="col-md-12">
              <label class="form-label optional">Terá imagem?</label>
              <div class="toggle-container">
                <label class="toggle-switch">
                  <input type="checkbox" [(ngModel)]="campanhaForm.temImagem" (change)="!campanhaForm.temImagem && removeImage()">
                  <span class="toggle-slider"></span>
                </label>
                <span class="toggle-label">{{ campanhaForm.temImagem ? 'Sim' : 'Não' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="form-section" *ngIf="campanhaForm.temImagem">
          <h3 class="section-title"><i class="fas fa-image me-2"></i>Imagem da Campanha</h3>

          <div class="image-upload-area">
            <div class="upload-zone" *ngIf="!campanhaForm.imagemPreview">
              <input type="file" accept="image/*" (change)="onImageSelected($event)" id="campanhaImagem" hidden>
              <label for="campanhaImagem" class="upload-label">
                <i class="fas fa-cloud-upload-alt"></i>
                <span>Clique para selecionar uma imagem</span>
                <small>PNG, JPG ou WEBP</small>
              </label>
            </div>

            <div class="mobile-preview-container" *ngIf="campanhaForm.imagemPreview">
              <p class="preview-title">Preview Mobile</p>
              <div class="mobile-frame">
                <div class="mobile-status-bar">
                  <span class="status-time">9:41</span>
                  <div class="status-icons">
                    <i class="fas fa-signal fa-xs"></i>
                    <i class="fas fa-wifi fa-xs"></i>
                    <i class="fas fa-battery-full fa-xs"></i>
                  </div>
                </div>
                <div class="mobile-screen">
                  <!-- App background content (blurred) -->
                  <div class="app-bg-content">
                    <div class="app-bg-bar"></div>
                    <div class="app-bg-card"></div>
                    <div class="app-bg-card short"></div>
                  </div>
                  <!-- Popup overlay -->
                  <div class="popup-overlay">
                    <div class="popup-card">
                      <button class="popup-close">✕</button>
                      <div class="popup-image">
                        <img [src]="campanhaForm.imagemPreview" alt="Preview da campanha">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mobile-home-indicator"></div>
              </div>
              <button class="btn btn-outline-danger btn-sm mt-3" (click)="removeImage()">
                <i class="fas fa-trash me-1"></i> Remover imagem
              </button>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button class="btn btn-outline-secondary" (click)="goBackToCampanhas()">
            <i class="fas fa-times me-2"></i>Cancelar
          </button>
          <button class="btn btn-primary" [disabled]="!isCampanhaFormValid" (click)="saveCampanha()">
            <i class="fas fa-save me-2"></i>Salvar Campanha
          </button>
        </div>
      </div>
    </div>

    <!-- Cobranças Push -->
    <div *ngIf="currentView === 'cobrancas-push'">
      <div class="page-header with-back">
        <button class="btn-back" (click)="goBack()">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div>
          <h2><i class="fas fa-bell me-2"></i>Cobranças Push</h2>
          <p class="page-subtitle">Envie notificações de cobrança via push</p>
        </div>
      </div>

      <app-table
        [title]="'Cobranças Push'"
        [data]="cobrancasPush"
        [columns]="cobrancasPushColumns"
        [showSearch]="true"
        [searchPlaceholder]="'Buscar cobranças...'"
        [clickable]="false">
        <app-button
          table-header-action
          text="Nova Cobrança Push"
          [color]="'var(--primary-light)'"
          [height]="'42px'"
          (buttonClick)="newCobrancaPush()">
        </app-button>
      </app-table>
    </div>

    <!-- Nova Cobrança Push -->
    <div *ngIf="currentView === 'nova-cobranca-push'">
      <div class="page-header with-back">
        <button class="btn-back" (click)="goBackToCobrancasPush()">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div>
          <h2><i class="fas fa-plus-circle me-2"></i>Nova Cobrança Push</h2>
          <p class="page-subtitle">Configure a notificação push de cobrança</p>
        </div>
      </div>

      <div class="push-form-layout">
        <div class="form-card push-form-fields">
          <div class="form-section">
            <h3 class="section-title"><i class="fas fa-info-circle me-2"></i>Informações da Notificação</h3>

            <div class="row g-3">
              <div class="col-md-12">
                <label class="form-label">Nome</label>
                <input type="text" class="form-control" [(ngModel)]="cobrancaPushForm.nome"
                  placeholder="Nome interno da cobrança (ex: Cobrança Março)">
              </div>

              <div class="col-md-12">
                <label class="form-label">Título da Notificação</label>
                <input type="text" class="form-control" [(ngModel)]="cobrancaPushForm.titulo"
                  placeholder="Título exibido no push (ex: Pagamento pendente)">
              </div>

              <div class="col-md-12">
                <label class="form-label">Conteúdo</label>
                <textarea class="form-control" [(ngModel)]="cobrancaPushForm.conteudo" rows="4"
                  placeholder="Texto da notificação push..."
                  maxlength="200"></textarea>
                <small class="char-count">{{ cobrancaPushForm.conteudo.length }}/200</small>
              </div>
            </div>
          </div>

          <div class="form-actions">
            <button class="btn btn-outline-secondary" (click)="goBackToCobrancasPush()">
              <i class="fas fa-times me-2"></i>Cancelar
            </button>
            <button class="btn btn-primary" [disabled]="!isCobrancaPushFormValid" (click)="saveCobrancaPush()">
              <i class="fas fa-paper-plane me-2"></i>Salvar Cobrança
            </button>
          </div>
        </div>

        <div class="push-preview-panel">
          <p class="preview-title">Preview Mobile</p>
          <div class="mobile-frame">
            <div class="mobile-status-bar">
              <span class="status-time">9:41</span>
              <div class="status-icons">
                <i class="fas fa-signal fa-xs"></i>
                <i class="fas fa-wifi fa-xs"></i>
                <i class="fas fa-battery-full fa-xs"></i>
              </div>
            </div>
            <div class="mobile-screen push-screen">
              <!-- Lock screen wallpaper -->
              <div class="lock-screen">
                <div class="lock-date">Segunda-feira</div>
                <div class="lock-time">9:41</div>

                <!-- Push notification -->
                <div class="push-notification" [class.has-content]="cobrancaPushForm.titulo || cobrancaPushForm.conteudo">
                  <div class="push-header">
                    <div class="push-app-icon">
                      <i class="fas fa-car"></i>
                    </div>
                    <span class="push-app-name">Loca9</span>
                    <span class="push-time">agora</span>
                  </div>
                  <div class="push-body">
                    <p class="push-title">{{ cobrancaPushForm.titulo || 'Título da notificação' }}</p>
                    <p class="push-text">{{ cobrancaPushForm.conteudo || 'Conteúdo da notificação aparecerá aqui...' }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="mobile-home-indicator"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</app-side-menu>
